// components/ErrorBoundary.jsx
import React from 'react';
import { NotFound, NotAuthorized, ServerError, DuplicateAttendee } from './HttpErrorHandler';
import Layout from './Layout'; // whatever your layout/shell component is

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;

    if (!error) return this.props.children;

    const status = error?.status || error?.response?.status;

    const ErrorComponent = () => {
      switch (status) {
        case 403: return <NotAuthorized />;
        case 402: return <DuplicateAttendee/>
        case 404: return <NotFound />;
        case 500: return <ServerError />;
        default:  return <ServerError />;
      }
    };

    return (
      <Layout>
        <ErrorComponent />
      </Layout>
    );
  }
}